<div class="accident-record" data-test="accident-record" [attr.data-testid]="'accident-' + getAccidentNatureValue(model.natureOfAccident) + '-' + (model.accidentDate | date: 'dd MMM yyyy')">
  <div class="info">
    <p class="accident-date">{{ model.accidentDate | date: 'dd MMM yyyy' }}</p>
    <p class="accident-nature">{{ getAccidentNatureValue(model.natureOfAccident) || getAccidentTitle(model) }}</p>
  </div>
  <div class="actions">
    @if (!model.noAccidents) {
      <mat-icon svgIcon="edit-black" (click)="onUpdateAccident()" data-test="edit-accident-record" [attr.data-testid]="getAccidentNatureValue(model.natureOfAccident) + '-editBtn'"></mat-icon>
    }
    <mat-icon svgIcon="delete-sweep-outlined" (click)="onDeleteAccident()" data-test="delete-accident-record" [attr.data-testid]="getAccidentNatureValue(model.natureOfAccident) + '-deleteBtn'"></mat-icon>
  </div>
</div>
